import React from "react";
import { prepFqReportStyles } from "../styles/prepFqReportStyles";
import { useTranslation } from "next-i18next";
import { Button, Paper } from "@mui/material";
import clsx from "clsx";
import JournalEntriesIcon from "../icons/JournalEntriesIcon";
import Link from "next/link";
import { ENHANCE_JOURNAL_ENTRIES } from "../../../constants/routes";

interface Props {
  height: number;
}

const JournalEntriesCard: React.FC<Props> = ({ height }) => {
  const classes = prepFqReportStyles();
  const { t } = useTranslation(["prepFq"]);
  return (
    <React.Fragment>
      <Paper
        elevation={0}
        className={clsx(
          classes.borderedCard,
          classes.borderedCardAlt,
          "twenty-first-step-journal-entries-card"
        )}
        style={{ height }}
      >
        <div className={classes.suggestionIconContainer}>
          <JournalEntriesIcon
            className={clsx(classes.suggestionIconSize, classes.lotsIcon)}
          />
        </div>
        <div className={classes.spaceBetweenBox}>
          <div>
            <h3 className={classes.suggestionsTitle}>
              {t("prepFq:report.journalEntries.title")}
            </h3>
            <p className={classes.promptText}>
              {t("prepFq:report.journalEntries.description")}
            </p>
          </div>
          <div className={clsx(classes.goButtonContainerAlt)}>
            <Link passHref href={ENHANCE_JOURNAL_ENTRIES}>
              <Button variant="contained" color="secondary">
                {t("prepFq:report.journalEntries.button")}
              </Button>
            </Link>
          </div>
        </div>
      </Paper>
    </React.Fragment>
  );
};

export default JournalEntriesCard;
